export enum GridProperties {
    Page = "Page",
    PageSize = "PageSize",
    Skip = "Skip",
    SortColumn = "SortColumn",
    SortDirection = "SortDirection",
    SearchText = "SearchText"
}